/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import _ from 'lodash'
import { observer } from 'mobx-react'
import { Row, Col, Modal } from 'antd'
import { compose } from 'recompose'
import PDFViewer from 'pdf-viewer-reactjs'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
    	const { visible, onCancel, certificate_url } = this.props
		// console.log('certificate_url', certificate_url)
    	return (
    		<React.Fragment>
				 <Modal
    				width='75%'
    				visible={visible}
    				title='View Certificate'
    				onCancel={onCancel}
					onOk={() => {
						window.open(certificate_url, '_blank')
					}}
    				destroyOnClose
					okText='Print'
    			>
    				<div style={{ backgroundColor: 'gray', paddingTop: 50 }}>
						<PDFViewer
							document={{
								url: certificate_url,
							}}
						/>
					</div>
    			</Modal>
    		</React.Fragment>
    	)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
